import styled from "styled-components";
import Icon from "../../../../../../../components/icon";
import { theme } from "../../../../../../../helpers/theme";
import { ReactComponent as WarningMessageIconSVG } from "../../../../../../../assets/icons/warning_message_icon.svg";


export const WorningIcon = () => {

    return (
        <WorningIconWrapper>
            <Icon
                width="20px"
                height="20px"
                noPadding
                icon={<WarningMessageIconSVG />}
            />
        </WorningIconWrapper>

    );
};

const WorningIconWrapper = styled.div`
margin-top:1px;
margin-left:10px;
`;
